import React, { useEffect, useState } from 'react';
import Button from '@material-ui/core/Button';
import PropTypes from 'prop-types';
import SwipeableViews from 'react-swipeable-views';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Box from '@material-ui/core/Box';
import ClipLoader from "react-spinners/ClipLoader";
import { Popup } from '../Global/Popup';
import { base_url } from '../Api/Api';
import { Loader } from '../Global/Loader';
import { Link } from 'react-router-dom';

function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`full-width-tabpanel-${index}`}
            aria-labelledby={`full-width-tab-${index}`}
            {...other}
            className="tab-style"
        >
            <Box>
                {children}
            </Box>
        </div>
    );
}
TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
};
function a11yProps(index) {
    return {
        id: `full-width-tab-${index}`,
        'aria-controls': `full-width-tabpanel-${index}`,
    };
}
const useStyles = makeStyles((theme) => ({
    root: {
        backgroundColor: theme.palette.background.paper,
        width: 500,
    },
}));

const Search = (props) => {

    const [state, setState] = useState({
        history: [],
        searchResult: [],
        loader: true,
        animToggle: false,
        historyStatus: false,
        searchValues: '',
        popupStatus: false
    })
    const [searchLoader, setSearchLoader] = useState(false)
    const classes = useStyles();
    const theme = useTheme();
    const [value, setValue] = React.useState(0);

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    const handleChangeIndex = (index) => {
        setValue(index);
    };

    useEffect(() => {
        callHistory()
    }, [])

    const callHistory = () => {

        base_url.get(`searchHistory`)
            .then(response => {
                console.log(response.data)
                setState({
                    ...state,
                    loader: false,
                    history: response.data.slice(0, 5),
                    animToggle: true,
                    historyStatus: !(response.data.length == 0)
                })
            })
            .catch(error => {
                if (error.response != undefined) {
                    console.log(error)
                    if (error.response.status == 401) {
                        localStorage.clear()
                        props.history.push(`/Entrance`)
                        window.location.reload()
                    }
                }
            })
    }

    const search = (value) => {

        setSearchLoader(true)
        if (value.trim().length > 0) {

            const headers = {
                "Authorization": JSON.parse(localStorage.getItem('api_key')),
                "content-type": "application/json",
            };
            const data = {
                text: value
            }
            base_url.post(`search`, data, {
                headers: headers
            })
                .then(response => {
                    console.log(response.data)
                    base_url.get(`searchHistory`, {
                        headers: headers
                    })
                        .then(resp => {
                            console.log(resp.data)
                            setState({
                                ...state,
                                loader: false,
                                history: resp.data.slice(0, 5),
                                animToggle: true,
                                searchResult: response.data,
                                searchValues: value,
                                historyStatus: false,
                                popupStatus: false
                            })
                            setSearchLoader(false)
                        })
                        .catch(error => {
                            if (error.response != undefined) {
                                console.log(error)
                                if (error.response.status == 401) {
                                    localStorage.clear()
                                    props.history.push(`/Entrance`)
                                    window.location.reload()
                                }
                            }
                        })
                })
                .catch(error => {
                    if (error.response != undefined) {
                        console.log(error)
                        if (error.response.status == 401) {
                            props.history.push(`/Entrance`)
                            localStorage.clear()
                            props.history.push(`/Entrance`)
                            window.location.reload()
                        } else if (error.response.status == 500) {
                            setState({
                                ...state,
                                popupStatus: true,
                                searchValues: value,
                            })
                            setSearchLoader(false)
                        }
                    }
                })
        } else if (value.length == 0) {
            setState({
                ...state,
                searchValues: value,
                historyStatus: true,
                popupStatus: false
            })
            setSearchLoader(false)
        }

    }

    const searchValue = (e, typeFiled) => {
        console.log(e)
        if (typeFiled == 'input') {
            search(e.target.value)
        } else {
            search(e)
        }
    }

    const deleteSingleHistory = (idItem) => {

        setState({
            ...state,
            loader: true
        })

        const data = {
            id: idItem
        }
        base_url.post(`cleareSingleSearch`, data)
            .then(response => {
                console.log(response.data)
                callHistory()
            })
            .catch(error => {
                if (error.response != undefined) {
                    console.log(error)
                    if (error.response.status == 401) {
                        props.history.push(`/Entrance`)
                    }
                }
            })
    }

    const deleteAllHistory = () => {
        setState({
            ...state,
            loader: true
        })

        const data = {}
        base_url.post(`cleareAllSearch`, data)
            .then(response => {
                console.log(response.data)
                callHistory()
            })
            .catch(error => {
                if (error.response != undefined) {
                    console.log(error)
                    if (error.response.status == 401) {
                        props.history.push(`/Entrance`)
                    }
                }
            })
    }

    return (
        <React.Fragment>
            <Loader
                active={state.loader} />
            <div className={`instructpg search-page ${state.animToggle ? 'active' : ''}`}>

                <Popup
                    active={state.popupStatus}>
                    <h4>مشکلی در سرور رخ داده است.</h4>
                    <div className="btn-base btn-black btn-sircle">
                        <Button
                            variant="contained"
                            onClick={(e) => searchValue(state.searchValues, 'button')}
                        >تلاش مجدد</Button>
                        <Button
                            variant="contained"
                            onClick={() => props.history.goBack()}
                        >خروج</Button>
                    </div>
                </Popup>

                <div className="input-search">
                    <i className="icon-arrow-down-sign-to-navigate-fill"
                        onClick={() => props.history.goBack()} ></i>
                    <input
                        type="text"
                        placeholder="جستجو کنید ..."
                        onChange={(e) => searchValue(e, 'input')} />

                    <div className="loader-search">
                        <ClipLoader
                            loading={searchLoader}
                            size={25}
                            color="#152b9f" />
                    </div>
                </div>
                <div className="body-search">

                    {state.historyStatus ?
                        <div className="history-list">
                            <h4>تاریخچه جستجو</h4>
                            <ul>
                                {state.history.map(item =>
                                    <li key={item.id}>
                                        <span>{item.text}</span>
                                        <i className="icon-close"
                                            onClick={() => deleteSingleHistory(item.id)} ></i>
                                    </li>
                                )}
                            </ul>
                            <button
                                type="button"
                                onClick={deleteAllHistory} >پاک کردن همه</button>
                        </div>
                        :
                        state.searchResult.length == 0 ? null :
                            (state.searchResult.course.length +
                                state.searchResult.learningContent.length +
                                state.searchResult.webinar.length) == 0 ?
                                <span className="no-info"> <i className="icon-search"></i> موردی برای جستجو یافت نشد.</span>
                                :
                                <React.Fragment>
                                    <AppBar position="static" color="default">
                                        <Tabs
                                            value={value}
                                            onChange={handleChange}
                                            indicatorColor="primary"
                                            textColor="primary"
                                            variant="fullWidth"
                                            aria-label="full width tabs example"
                                        >
                                            <Tab label="همه" {...a11yProps(0)} />
                                            <Tab label="کرس درسی" {...a11yProps(1)} />
                                            <Tab label="محتوای آموزشی" {...a11yProps(2)} />
                                            <Tab label="وبینار" {...a11yProps(3)} />
                                        </Tabs>
                                    </AppBar>
                                    <SwipeableViews
                                        axis={theme.direction === 'ltr' ? 'x-reverse' : 'x'}
                                        index={value}
                                        onChangeIndex={handleChangeIndex}
                                    >
                                        <TabPanel className="tab-style" value={value} index={0} dir={theme.direction}>
                                            {state.searchResult.course.length == 0 ? null :
                                                <div className="style-searcbox">
                                                    <h4>کرس درسی ({state.searchResult.course.length})</h4>
                                                    {state.searchResult.course.map(item =>
                                                        <Link to={`/${item.id}`}>{item.title}</Link>
                                                    )}
                                                </div>
                                            }
                                            {state.searchResult.learningContent.length == 0 ? null :
                                                <div className="style-searcbox">
                                                    <h4>محتوای آموزشی ({state.searchResult.learningContent.length})</h4>
                                                    {state.searchResult.learningContent.map(item =>
                                                        <Link to={`/Education/content/${item.id}`}>{item.title}</Link>
                                                    )}
                                                </div>
                                            }
                                            {state.searchResult.webinar.length == 0 ? null :
                                                <div className="style-searcbox">
                                                    <h4>وبینار ({state.searchResult.webinar.length})</h4>
                                                    {state.searchResult.webinar.map(item =>
                                                        <Link to={`/myWebinars/detailes/${item.id}`}>{item.title}</Link>
                                                    )}
                                                </div>
                                            }
                                        </TabPanel>
                                        {state.searchResult.course.length == 0 ?
                                            <span className="no-info"> <i className="icon-search"></i> موردی برای جستجو یافت نشد.</span>
                                            :
                                            <TabPanel className="tab-style" value={value} index={1} dir={theme.direction}>
                                                <div className="style-searcbox">
                                                    <h4>کرس درسی ({state.searchResult.course.length})</h4>
                                                    {state.searchResult.course.map(item =>
                                                        <Link to={`/${item.id}`}>{item.title}</Link>
                                                    )}
                                                </div>
                                            </TabPanel>
                                        }
                                        {state.searchResult.learningContent.length == 0 ?
                                            <span className="no-info"> <i className="icon-search"></i> موردی برای جستجو یافت نشد.</span>
                                            :
                                            <TabPanel className="tab-style" value={value} index={2} dir={theme.direction}>
                                                <div className="style-searcbox">
                                                    <h4>محتوای آموزشی ({state.searchResult.learningContent.length})</h4>
                                                    {state.searchResult.learningContent.map(item =>
                                                        <Link to={`/Education/content/${item.id}`}>{item.title}</Link>
                                                    )}
                                                </div>
                                            </TabPanel>
                                        }
                                        {state.searchResult.webinar.length == 0 ?
                                            <span className="no-info"> <i className="icon-search"></i> موردی برای جستجو یافت نشد.</span>
                                            :
                                            <TabPanel className="tab-style" value={value} index={3} dir={theme.direction}>
                                                <div className="style-searcbox">
                                                    <h4>وبینار ({state.searchResult.webinar.length})</h4>
                                                    {state.searchResult.webinar.map(item =>
                                                        <Link to={`/myWebinars/detailes/${item.id}`}>{item.title}</Link>
                                                    )}
                                                </div>
                                            </TabPanel>
                                        }
                                    </SwipeableViews>
                                </React.Fragment>
                    }

                </div>

            </div>
        </React.Fragment>
    );
}

export default Search;